import * as Yup from 'yup';

export const smartserve = Yup.string().max(
  50,
  'Smartserve number should be less than 50 symbols',
);
